module.exports = __webpack_public_path__ + "64379f2c420c4916cf2baa791ba39ff1.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/images/paywalls/log-reading.gif
// module id = 3340
// module chunks = 0